// 數據看板主頁面組件
export default {
  // 新手引導
  finishButton: "完成",

  // 搜索框
  searchPlaceholder: "請輸入你要搜索的案件",
  searchButton: "查詢",

  // 消息提示
  dataLoading: "案件數據拉取中，預計需要一天時間，請耐心等待！",
  noSearchResult: "你搜索的案件暫無結果！",
  noData: "暫無",
};
